export const transformCurrency = (amount = '', decimalPlaces = 2) =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(parseInt(amount, 10) / Math.pow(10, decimalPlaces));
